// app/frontend/pages/FAQ.tsx
import React from 'react';
import { Head, Link } from '@inertiajs/react';
import { Container, Title, Accordion, Text, Anchor } from '@mantine/core';
import Layout from '../components/Layout';
import { faqData } from '../data/faqData';
import '../styles/FAQ.css';

const FAQ: React.FC = () => {
  return (
    <>
      <Head>
        <title>FAQs | WhereCanWeDance</title>
        <meta property="og:title" content="FAQs | WhereCanWeDance" />
        <meta
          property="og:description"
          content="Frequently asked questions about WhereCanWeDance - find answers about events, artists, and how to use our platform."
        />
        <meta property="og:type" content="website" />
      </Head>

      <Container size="sm" py="xl">
        <Title order={1} ta="center" mb="xl" fw={700} className="rubik-header">
          FAQs
        </Title>

        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <Title order={2} mb="md" className="poppins text-white" mt={sectionIndex > 0 ? 'xl' : undefined}>
              {section.section}
            </Title>

            <Accordion
              mb="xl"
              classNames={{
                control: 'faq-accordion-control',
                content: 'faq-accordion-content',
                item: 'faq-accordion-item',
                chevron: 'faq-accordion-chevron',
              }}
            >
              {section.items.map((item, itemIndex) => (
                <Accordion.Item key={itemIndex} value={`${sectionIndex}-${itemIndex}`}>
                  <Accordion.Control>{item.question}</Accordion.Control>
                  <Accordion.Panel>
                    {typeof item.answer === 'string' ? <Text>{item.answer}</Text> : item.answer}
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        ))}
      </Container>
    </>
  );
};

// Set the layout
FAQ.layout = (page: React.ReactElement) => <Layout>{page}</Layout>;

export default FAQ;
